<template>
  <div>
    <Toast />
    <div class="form col-lg-10 mx-auto bg-white">
      <form class="col-lg-11 mx-auto">
        <h6 class="text-center mt-2 pt-3 mb-3 heading">
          Success! You are on the last step to registering
          <br />{{ company_name }}
        </h6>

        <div class="col-lg-4 mx-auto svg-container ">
          <img src="../../../assets/2985673.svg" alt srcset />
        </div>
        <div class="d-flex m-3 item">
          <p>By continuing, you confirm the registration of Your Company</p>
        </div>
        <div class="d-flex m-3 item button">
          <button @click.prevent="downloadPDF" class="btn btn-primary">
            Download registered info
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import jsPDF from "jspdf";
import "jspdf-autotable";
import axios from "axios";
import { capitalize } from "lodash";
let config = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("jwt"),
  },
};
export default {
  data() {
    return {
      drivers: [],
      shalois: [],
      bps: [],
      buses: [],
      branches: [],
      company_name: "",
      branch_info: [],
      drivers_info: [],
      shalois_info: [],
      buses_info: [],
      breakpoint_info: [],
    };
  },
  methods: {
    downloadPDF() {
      var pdf = new jsPDF();
      pdf.text(this.company_name, 90, 10);

      //drivers
      pdf.autoTable({
        head: [["DriverFirstname", "DriverLastname","Email","Phonenumber"]],
        body: [...this.drivers_info],
      });

      //shalois
      pdf.autoTable({
        head: [["ShaloiFirstname", "ShaloiLastname","Email","Phonenumber"]],
        body: [...this.shalois_info],
      });

      //buses
      pdf.autoTable({
        head: [["Busplateno", "Sits", "driver"]],
        body: [...this.buses_info],
      });

      //branches
      pdf.autoTable({
        head: [["BranchName", "Location", "shaloi"]],
        body: [...this.branch_info],
      });

      //bps
      pdf.autoTable({
        head: [["RouteSource", "RouteDestination", "Price"]],
        body: [...this.breakpoint_info],
      });

      pdf.save(`${this.company_name}-bookinga.pdf`);
    },
  },
  mounted() {
    axios
      .get("https://bookinga.herokuapp.com/api/v1/company/admin/info", config)
      .then((res) => {
        // console.log(res.data, "davidman");

        //drivers
        this.drivers = res.data.drivers;
        for (let i = 0; i < this.drivers.length; i++) {
          this.drivers_info[i] = [];
          this.drivers_info[i][0] = this.drivers[i].firstname;
          this.drivers_info[i][1] = this.drivers[i].lastname;
          this.drivers_info[i][2] = this.drivers[i].email;
          this.drivers_info[i][3] = this.drivers[i].phonenumber;
        }

        //shalois
        this.shalois = res.data.shalois;
        for (let i = 0; i < this.shalois.length; i++) {
          this.shalois_info[i] = [];
          this.shalois_info[i][0] = this.shalois[i].firstname;
          this.shalois_info[i][1] = this.shalois[i].lastname;
          this.shalois_info[i][2] = this.shalois[i].email;
          this.shalois_info[i][3] = this.shalois[i].phonenumber;
        }

        //breakpoints
        this.bps = res.data.breakpoints;
        for (let i = 0; i < this.bps.length; i++) {
          this.breakpoint_info[i] = [];
          this.breakpoint_info[i][0] = this.bps[i].source;
          this.breakpoint_info[i][1] = this.bps[i].destination;
          this.breakpoint_info[i][2] = this.bps[i].price;
        }

        //buses
        this.buses = res.data.buses;
        for (let i = 0; i < this.buses.length; i++) {
          this.buses_info[i] = [];
          this.buses_info[i][0] = this.buses[i].busplatenumber;
          this.buses_info[i][1] = this.buses[i].capacity;
          this.buses_info[i][2] = this.buses[i].firstname + " " + this.buses[i].lastname;
        }

        //branches
        this.branches = res.data.branches;
        for (let i = 0; i < this.branches.length; i++) {
          this.branch_info[i] = [];
          this.branch_info[i][0] = this.branches[i].branchname;
          this.branch_info[i][1] = this.branches[i].office_location;
          this.branch_info[i][2] = this.branches[i].firstname + " " + this.branches[i].lastname;
        }

        //companyname
        this.company_name = capitalize(res.data.name);
      });
  },
};
</script>

<style lang="scss" scoped>
.form {
  border-radius: 10px;
  height: 85vh;
}
.heading {
  font-size: 20px;
  margin-bottom: 1.25rem !important;
}

p {
  color: $mainDark;
  font-size: 0.95em;
  font-weight: 400;
  margin-left: 2%;
}

.d-flex {
  justify-content: center;
}
.item {
  align-items: center;
}
button {
  min-height: 40px;
  min-width: fit-content;
  width: 100% !important;
}
.button{
  width: 40% !important;
  margin: auto !important;
}
.text-white {
  color: white !important;
}
.btn {
  font-size: 0.85em;
}
.svg-container{
  justify-content: center;
  align-items: center;
  display: flex;
}

@media only screen and (max-width: 600px) {
  .button {
    width: 62% !important;
  }
}
</style>
